import _ from 'lodash';

import worldMap from '../../core/map';
import environment from '../../environment';
import AreaSharedAfterSalesLayer from './AreaSharedAfterSalesLayer';

const LayerControls = (name) => require('../../controls').get(name);
const LayerInfo = (name) => require('../../info').get(name);

const name = 'MarkedAreaAfterSales';

class MarkedAreaAfterSalesLayer extends AreaSharedAfterSalesLayer {
    constructor(currentMap) {
        const mapId = currentMap._id;

        const onClick = (feature) => {
            try {
                if (worldMap.getCurrent()._id === mapId) {
                    const status = LayerInfo(name).check(feature.properties.Id) ? 'uncheck' : 'check';
                    $(`#MarkedAreaAfterSales-selection-${feature.properties.Id}`).iCheck(status);
                }
            } catch (err) {
                console.log(err);
            }
        };

        const fncIdLayerType = (() => {
            try {
                return environment.get('CONFIG.FILTERS.MARKED_AREA_TYPES')[_.take(_.keys(environment.get('CONFIG.FILTERS.MARKED_AREA_TYPES')), 1)[0]].id;
            } catch (error) {
                return 0;
            }
        });

        const options = {
            name,
            onClick,
            fncIdLayerType,
        };

        super(currentMap, options);
    }
}

export default MarkedAreaAfterSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/AfterSales/MarkedAreaAfterSalesLayer.js